import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * View-only imitation of another user by a Gently admin.
 *
 * There is deliberately no `status` procedure: `/auth/me` already carries the
 * active imitation block, so the client never has to poll a second source.
 */
export const imitationContracts = {
  /**
   * Start imitating an active user in the real admin's current organization.
   * Rejected when imitation is already active — imitation never nests.
   */
  start: oc
    .input(z.object({ userId: z.string() }))
    .output(z.object({ imitatedUserId: z.string() }))
    .route({
      summary: "Start imitating another user",
      description:
        "Admin only. Starts a view-only session as another active user in the admin's current organization; fails if imitation is already active or the user is deactivated.",
      method: "POST",
    }),

  /**
   * End imitation and return to the real admin identity. Idempotent: calling
   * it while not imitating succeeds with `stopped: false`.
   */
  stop: oc.output(z.object({ stopped: z.boolean() })).route({
    summary: "Stop imitating a user",
    description:
      "Ends view-only imitation and returns to the admin's own identity. Safe to call when not imitating.",
    method: "POST",
  }),
} as const;
